export var HeaderType;
(function (HeaderType) {
    HeaderType["none"] = "none";
    HeaderType["default"] = "default";
})(HeaderType || (HeaderType = {}));
